import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import RightArrow from '../../../assets/RightArrow';
import LeftArrow from '../../../assets/LeftArrow';
import CalenderIcon from '../../../assets/CalenderIcon';
import {
  formatDate,
  getNextDay,
  getPreviousDay,
} from '../../../utils/dateUtils';
import CalenderIconDark from '../../../assets/CalenderIconDark';
import LeftArrowDark from '../../../assets/LeftArrowDark';
import RightArrowDark from '../../../assets/RightArrowDark';

interface DateSelectorProps {
  onDateChange: (date: Date | null) => void;
  initialDate: Date;
  showArrows?: boolean;
  className?: string;
}

const DateSelector: React.FC<DateSelectorProps> = ({
  onDateChange,
  initialDate,
  showArrows,
  className,
}) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(initialDate);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setSelectedDate(initialDate);
  }, [initialDate]);

  // Handlers to go to the previous and next day
  const goToPreviousDay = () => {
    if (selectedDate) {
      const previewDate = getPreviousDay(selectedDate);
      setSelectedDate(previewDate);
      onDateChange(previewDate);
    }
  };

  const goToNextDay = () => {
    // console.log();
    if (selectedDate) {
      const nextDay = getNextDay(selectedDate);
      setSelectedDate(nextDay);
      onDateChange(nextDay);
    }
  };
  // Handle date change from DatePicker
  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
    onDateChange(date); // Call the parent function
    setIsOpen(false);
  };

  // Custom date format
  const formattedDate =
    selectedDate !== null ? formatDate(selectedDate) : 'Select a date';

  const toggleDatePicker = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`flex items-center ${className || 'w-full'}`}>
      {/* Display Selected Date */}
      {showArrows && (
        <button
          className="text-text-primary font-bold mx-2"
          onClick={goToPreviousDay}
          disabled={!selectedDate}
        >
          <div>
            <div className="block dark:hidden">
              <LeftArrow />
            </div>
            <div className="hidden dark:block">
              <LeftArrowDark />
            </div>
          </div>
        </button>
      )}
      <span className="text-textColor">
        <div className="mr-2">
          <div className="block dark:hidden">
            <CalenderIcon />
          </div>
          <div className="hidden dark:block">
            <CalenderIconDark />
          </div>
        </div>
      </span>
      <div className="mb-1">
        <DatePicker
          popperPlacement="bottom-start"
          selected={selectedDate}
          onChange={handleDateChange}
          calendarClassName="custom-datepicker"
          open={isOpen}
          onClickOutside={() => setIsOpen(false)}
          customInput={
            <div className="cursor-pointer text-lg">
              <span
                className="text-text-primary text-sm text-nowrap"
                onClick={toggleDatePicker}
              >
                {formattedDate}
              </span>
            </div>
          }
        />
      </div>

      {showArrows && (
        <button
          className="text-textColor mx-2"
          onClick={goToNextDay}
          disabled={!selectedDate}
        >
          <div>
            <div className="block dark:hidden">
              <RightArrow />
            </div>
            <div className="hidden dark:block">
              <RightArrowDark />
            </div>
          </div>
        </button>
      )}
    </div>
  );
};

export default DateSelector;
